module.exports = __webpack_public_path__ + "static/media/banner2.78fd80bc.jpg";